export default __webpack_public_path__ + "fc93859ba2c3797ae84899cfcead8353.ttf";